import { Observable } from 'rxjs';

import { LoadingService } from '../services';
import { SharedModule } from '../shared.module';

export function LoadingWrapper<T>(loadingTag: string): MethodDecorator {
    return function (target: unknown, propertyKey: string, descriptor: PropertyDescriptor): void {
        const originalMethod: Function = descriptor.value;

        descriptor.value = function (...args: unknown[]): Observable<unknown> {
            const loadingServiceInstance: LoadingService = SharedModule?.injector.get(LoadingService);

            return loadingServiceInstance.loadingWrapper<T>(originalMethod.apply(this, args), loadingTag);
        };
    };
}
